import { DecimalPipe } from "@angular/common";
import { CdkTableModule } from "@angular/cdk/table";
import { Component, forwardRef, HostListener, Input, output } from "@angular/core";
import { ButtonIcon, Modal, ModalHeaderDefault } from "@ui";
import { CellRendererDirective } from "./cell-renderer.directive";
import type { CellRendererItem } from "./cell-renderer-item";
import type { Page } from "./grid-data.provider";

@Component({
  selector: "app-cell-zoom-modal",
  templateUrl: "./cell-zoom-modal.component.html",
  styleUrls: ["./cell-zoom-modal.component.scss"],
  imports: [
    CdkTableModule,
    Modal,
    ModalHeaderDefault,
    ButtonIcon,
    forwardRef(() => CellRendererDirective),
    DecimalPipe,
  ],
})
export class CellZoomModalComponent {
  readonly columns = ["rowNumber", "value"];

  readonly closed = output<void>();

  public cellRenderer: CellRendererItem | undefined;
  @Input() row: any;
  @Input() rowIndex = 0;
  public column: any;
  @Input() value: any; // The value in the cell
  public page: Page | undefined; // the page the value is on

  showNext(goDown: boolean = true) {
    const increment = goDown ? 1 : -1;
    const nextIndex = this.rowIndex + increment;
    if (nextIndex < 0 || nextIndex >= (this.page?.rows.length ?? 0)) {
      return; // TODO: load the next page
    }
    this.rowIndex = nextIndex;
    this.row = this.page?.rows[nextIndex];
    this.value = this.row[this.column?.prop];
  }

  numWords() {
    return this.value ? this.value.split(" ").length : 0;
  }

  numCharacters() {
    // converting the string into an array will account for *some of* the funkiness of unicode surrogate pairs
    return this.value ? [...this.value].length : 0;
  }

  @HostListener("window:keydown", ["$event"])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode === 38) {
      // up arrow
      this.showNext(false);
    }
    if (event.keyCode === 40) {
      // down arrow
      this.showNext(true);
    }
  }
}
